export const aiDevBannerContent = {
    mainHeading: "AI Development",
    greenHeading: "Services",
    greenSubHeading: "Leverage AI the way it’s meant to be.",
    sectionDescription: "Improve your business with automation, chatbots, generative AI, custom applications, advanced reporting, & more. The possibilities are endless with our AI services.",
    bannerButtonText: "Let's Get Started"
}

export const aiPowerSectionContent = {
    heading: "Unlock the Power of Artificial Intelligence - The Bitsclan Way",
    description:
        "No technology has revolutionized the business landscape more profoundly than Artificial Intelligence in the last 30 years. Today, AI is the biggest catalyst for transformation in the business world.",
    button: {
        text: "Let's Connect",
        link: "/contact-us",
        iconClass: "fa-solid fa-arrow-right",
        iconStyle: {
            color: "#80B927",
            fontSize: "18px",
            marginTop: "4px",
        },
    },
    objectives: [
        {
            value: "$1.3 Trillion",
            label: "Estimated market value of AI by the year 2032",
        },
        {
            value: "54%",
            label: "Companies have implemented GenAI in some areas of their business.",
            customStyle: { paddingInlineStart: "60px", paddingRight: "0px" },
        },
        {
            value: "$415.81 Billion",
            label: "The projected value of the AI market in the US alone by the end of this decade",
        },
        {
            value: "7 in 10",
            label: "Organizations have specific training programs for workers for Generative AI",
            customStyle: { paddingInlineStart: "60px", paddingRight: "0px" },
        },
    ],
};

export const AiDevelopmentServicesData = {
    sectionContent: {
        mainHeading: "Tap into the future with our AI development Service",
        sectionDescription: "AI is not just a technology; it is the future. Every business today can use AI to boost operational efficiency, automate processes, & scale revenue. The question is how. That's where Bitsclan IT Solutions comes in. Explore our artificial intelligence services below."
    },

    tabsData: [
        {
            id: "Tab1",
            label: "AI Product Development",
            content:
                "Artificial intelligence is revolutionizing industries, & our AI product development services help businesses harness its power to create innovative, intelligent solutions. We specialize in developing AI-powered products that enhance efficiency, automate complex processes, & deliver superior user experiences. Whether it's intelligent automation tools, predictive analytics solutions, or AI-driven applications, we ensure seamless integration of AI capabilities tailored to your unique needs. Our team works closely with clients from ideation to deployment, ensuring that each AI product is designed for scalability, reliability, & performance.",
            secondContent: "With expertise in machine learning, natural language processing, & deep learning, we build AI solutions that drive business growth. Whether you're looking to streamline customer interactions, optimize decision-making, or enhance operational efficiency, our AI-driven products empower businesses with cutting-edge technology. From AI-powered chatbots & recommendation engines to smart data processing systems, we transform your vision into high-performance AI solutions that deliver tangible results.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab4",
            label: "Automation Solutions",
            content:
                "Automation is the key to unlocking greater efficiency & reducing operational costs in today's fast-paced digital world. Our AI-driven automation solutions help businesses streamline repetitive tasks, eliminate human errors, & optimize workflows. By leveraging robotic process automation (RPA), intelligent workflow management, & AI-powered decision-making, we enable companies to accelerate productivity & free up valuable resources. Our automation solutions are designed to integrate seamlessly with existing systems, ensuring minimal disruption while maximizing efficiency & accuracy.",
            secondContent: "From customer service chatbots to AI-powered document processing & smart workflow automation, our solutions drive business transformation. Whether you need automated data entry, fraud detection, or intelligent process automation, we develop AI-driven tools that enhance operational speed & precision. By implementing our automation solutions, businesses can improve service delivery, boost employee productivity, & stay ahead of the competition in an increasingly automated landscape.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab5",
            label: "AI as a Service",
            content:
                "Not every business has the resources or expertise to develop AI models from scratch, which is why our AI as a Service (AIaaS) solutions make artificial intelligence accessible to all. We provide ready-to-use AI models & cloud-based AI services that businesses can integrate into their existing systems without the complexity of in-house development. Our AIaaS offerings include machine learning-based analytics, intelligent automation tools, & AI-powered customer engagement solutions, all designed to scale with your business needs.",
            secondContent: "With our AIaaS solutions, you can leverage the power of AI for predictive analytics, fraud detection, personalized recommendations, & more—without heavy upfront investment. Our expert team ensures smooth integration, allowing businesses to enhance decision-making, automate processes, & drive innovation effortlessly. Whether you're a startup looking to integrate AI into your product or an enterprise seeking advanced AI capabilities, our AIaaS solutions provide a cost-effective way to stay ahead in the AI revolution.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab6",
            label: "AI Integration",
            content:
                "Seamlessly integrating AI into your existing systems can dramatically improve efficiency & decision-making. Our AI integration services help businesses leverage artificial intelligence to enhance their applications, workflows, & customer experiences. Whether you need AI-driven automation, predictive analytics, or intelligent recommendation engines, we ensure smooth AI adoption without disrupting your operations. Our team specializes in integrating AI capabilities into CRM systems, ERP platforms, & custom business applications to optimize performance & user engagement.",
            secondContent: "By embedding AI into your infrastructure, businesses can gain deeper insights, automate repetitive tasks, & create personalized user experiences. From chatbots that enhance customer support to AI-powered data processing that improves accuracy, our AI integration solutions drive innovation & efficiency. We ensure that AI aligns with your business objectives, enabling smarter decision-making & improved operational outcomes while maintaining security & scalability.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab7",
            label: "Prompt Engineering",
            content:
                "Effective AI interactions depend on well-optimized prompts that ensure accurate & relevant responses. Our prompt engineering services refine & optimize AI model inputs to enhance the quality of responses in chatbots, automation tools, & generative AI applications. By fine-tuning prompts for large language models (LLMs) & AI assistants, we ensure that AI-powered systems understand context, reduce ambiguity, & provide meaningful, accurate answers.",
            secondContent: "Our expertise in prompt design helps businesses build AI-driven tools that improve customer interactions, automate content generation, & streamline workflow automation. Whether you're developing AI chatbots for customer support or using AI for intelligent content creation, our optimized prompts enhance response quality, ensuring AI systems communicate effectively. We ensure that AI interactions align with business goals, delivering intelligent & user-friendly AI experiences.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab8",
            label: "Predictive Analytics Models",
            content:
                "In today’s data-driven world, businesses need accurate insights to stay competitive. Our predictive analytics models use AI & machine learning to analyze historical data, identify patterns, & generate forecasts that drive informed decision-making. Whether you're in finance, healthcare, retail, or any other industry, our AI-powered predictive analytics help optimize operations, improve risk assessment, & uncover growth opportunities. Our models are designed to process vast amounts of data in real-time, delivering accurate & actionable insights.",
            secondContent: "From demand forecasting & customer behavior analysis to fraud detection & market trend prediction, our predictive analytics solutions empower businesses to make proactive, data-backed decisions. By leveraging AI-driven forecasting, businesses can minimize risks, improve resource allocation, & gain a competitive edge. Our predictive models continuously learn & adapt, ensuring that your business stays ahead of market trends & customer demands.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab10",
            label: "Natural language processing",
            content:
                "Natural language processing (NLP) enables machines to understand & interpret human language, revolutionizing how businesses interact with customers & process information. Our NLP solutions help businesses develop AI-powered chatbots, sentiment analysis tools, speech recognition systems, & automated content processing solutions. By leveraging advanced NLP techniques, we enable businesses to extract insights from text & voice data, automate customer interactions, & improve overall communication efficiency.",
            secondContent: "Our NLP models power intelligent search engines, virtual assistants, & automated document analysis tools that enhance business operations. Whether you need an AI-powered chatbot for customer support or sentiment analysis for brand monitoring, our NLP solutions ensure accurate, context-aware processing of human language. By integrating NLP into your business, you can improve customer engagement, optimize workflows, & enhance decision-making with AI-powered language understanding.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab11",
            label: "Computer vision",
            content:
                "Computer vision technology enables machines to interpret & analyze visual data, opening new possibilities in automation, security, & business intelligence. Our AI-powered computer vision solutions include image recognition, object detection, facial recognition, & automated visual inspection systems. Businesses across industries use computer vision to enhance security, improve quality control, & automate data extraction from images & videos.",
            secondContent: "From smart surveillance systems to AI-powered quality assurance in manufacturing, our computer vision solutions enhance operational efficiency & accuracy. We develop AI-driven image processing systems for healthcare, retail, & industrial applications, enabling businesses to analyze & act on visual information in real time. Whether you need automated image classification, medical imaging analysis, or smart inventory tracking, our cutting-edge computer vision technology helps businesses optimize their processes.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab12",
            label: "Deep learning",
            content:
                "Deep learning is at the forefront of AI innovation, driving advanced automation, predictive modeling, & intelligent decision-making. Our deep learning solutions leverage neural networks to process large datasets, recognize patterns, & make accurate predictions. Businesses use deep learning for applications such as speech recognition, fraud detection, self-learning AI systems, & recommendation engines. Our expertise in deep learning ensures businesses harness its power to optimize operations & enhance customer experiences.",
            secondContent: "With deep learning models, businesses can achieve superior accuracy in AI applications, from personalized content recommendations to autonomous systems. Whether you're looking to implement AI-powered diagnostics in healthcare, fraud prevention in finance, or intelligent automation in retail, our deep learning solutions provide unparalleled performance. By integrating deep learning into your business, you gain access to powerful AI capabilities that drive innovation & efficiency.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
        {
            id: "Tab13",
            label: "Machine learning",
            content:
                "Machine learning transforms raw data into intelligent insights, helping businesses automate processes & make data-driven decisions. Our custom machine learning models analyze complex datasets to identify trends, detect anomalies, & optimize business operations. Whether you're building AI-driven recommendation engines, automated fraud detection systems, or predictive maintenance tools, our ML solutions provide powerful, scalable intelligence tailored to your needs.",
            secondContent: "By implementing machine learning, businesses can improve efficiency, enhance personalization, & drive automation. Our expertise spans supervised, unsupervised, & reinforcement learning techniques, ensuring businesses leverage AI for maximum impact. Whether you need customer segmentation, demand forecasting, or intelligent data processing, our machine learning solutions turn data into valuable business intelligence.",
            btnText: "Let's Discuss",
            btnLink: "#",
            imgs: [
                {
                    img: "/images/services-icons/ai-development/langchain-color.png",
                },
                {
                    img: "/images/services-icons/ai-development/open-cv.png",
                },
                {
                    img: "/images/services-icons/ai-development/SpaCy_logo.png",
                },
                {
                    img: "/images/services-icons/ai-development/TensorFlow_logo.png",
                },
            ],
        },
    ]
}

export const aiDevelopmentBoxContent = {
    heading: {
        part1: "Not only an",
        highlighted: "AI Development Company",
        part2: "We Are Your Partners in Business Transformation.",
    },
    paragraphs: [
        "As a top-rated AI consulting & development company, we don’t believe in a one-size-fits-all approach. We understand that every business has unique challenges, needs, & requirements.",
        "Hence, our AI solutions are tailored to ensure the best outcomes for our clients. Whether it is modernizing your legacy systems, integrating AI capabilities into your existing products, or custom AI development solutions, we have you covered.",
    ],
    button: {
        text: "Schedule a Call",
        url: "https://calendly.com/bitsclansolutions/15min",
        iconClass: "fa-solid fa-arrow-right",
    },
};

export const IndustriesSectionContent = {
    mainHeading: "Pioneering Change",
    lightHeading: "Across Industries",
    sectionDescription: "Our AI & IT services & solutions create long lasting competitive advantages & support diverse use cases across all major industries."
}

export const AIDevPageSolutionsSection = {
    heading: "Build Future-ready Solutions With Our",
    greenHeading: "AI Development Services",
    subHeading:
        "As a dedicated AI development company, we are the experts in the field of Artificial Intelligence. Our AI experts are among the best in the domain with years of experience in automation services.",
    solutions: [
        {
            title: "Machine Learning",
            description:
                "Build intelligent systems with machine learning solutions that learn from data. Applications include recommendation systems, predictive maintenance, & fraud detection.",
        },
        {
            title: "Deep Learning",
            description:
                "Leverage deep learning to analyze complex data. From image & speech recognition to autonomous systems, our AI solutions transform how data drives decisions.",
        },
        {
            title: "Computer Vision",
            description:
                "Empower machines to interpret visuals with AI development services. Key uses include facial recognition, object detection, medical imaging, & inspections.",
            noBorder: true,
        },
        {
            title: "Natural Language Processing (NLP)",
            description:
                "Enhance interactions with NLP tools for chatbots, sentiment analysis, voice recognition, & language translation, creating seamless human-AI communication.",
        },
        {
            title: "Robotic Process Automation (RPA)",
            description:
                "Automate repetitive tasks with RPA solutions. Boost efficiency, reduce costs, & eliminate human errors to focus on strategic goals with smarter workflows.",
        },
        {
            title: "Convolutional Neural Networks (CNNs)",
            description:
                "Use CNNs for visual data processing. Ideal for image & video recognition, medical imaging, & creating powerful AI solutions for advanced visual analysis.",
            noBorder: true,
        },
    ],
};

export const AIDevWhyUsContent = {
    heading: "Why Bitsclan as your Artificial Intelligence Development Company?",
    subHeading:
        "As a customer-centric AI development & consulting company, We offer tailored AI development services to meet the unique needs of various industries. Our expertise helps you leverage advanced technologies to address your industry's specific challenges & opportunities.",
    features: [
        {
            icon: "/images/premium.png",
            alt: "Premium",
            title: "Quality Because",
            span: "It Matters",
            description:
                "We deliver AI solutions tailored to your needs. With rigorous testing & validation, we ensure reliable, high-quality results that drive meaningful outcomes.",
        },
        {
            icon: "/images/best-bred.png",
            alt: "Best Brands",
            title: "The Best-of-the-Breed",
            span: "Talent",
            description:
                "Our team of top-tier experts combines innovation & technical knowledge. We create custom AI development solutions using the latest technologies to solve your challenges.",
        },
        {
            icon: "/images/time-zone.png",
            alt: "Time Zone",
            title: "Time Zone",
            span: "Alignment",
            description:
                "We align with your time zone for seamless communication & quick turnarounds. Real-time collaboration ensures your AI projects meet deadlines with precision.",
        },
        {
            icon: "/images/tech-upd.png",
            alt: "Tech Updated",
            title: "Up-to-Date",
            span: "Technology",
            description:
                "Using advanced AI technologies, we craft cutting-edge solutions. Staying updated helps us deliver innovation & industry-leading AI development services for you.",
        },
        {
            icon: "/images/conviction.png",
            alt: "conviction",
            title: "Our",
            span: "Conviction",
            description:
                "We take ownership of your projects with dedication & excellence. Our AI solutions are tailored to your goals, ensuring they meet the highest standards.",
        },
    ],
    button: {
        text: "Schedule a Call",
        link: "https://calendly.com/bitsclan-it/30min?month=2025-01",
    },
};

export const AIDevRoadmapContent = {
    mainHeading: "Our Proven Roadmap to ",
    greenHeading: "Ensure Your Success",
    sectionDescription: "As a leading AI development services provider, we have developed a structured roadmap to ensure the success of your projects. From initial discovery to ongoing support, we follow a systematic approach that guarantees alignment with your business goals, delivers high-quality solutions, & provides continuous improvement. Here’s how we do it:",

    leftColumn: [
        {
            title: "Design & Proof of Concept",
            description:
                "Turn your ideas into reality with a clear proof of concept. We design architectures & validate feasibility, ensuring custom AI development tailored to your needs.",
            className: "second",
        },
        {
            title: "Development & Testing",
            description:
                "Our team builds, tests, & refines your AI systems, ensuring smooth functionality. With rigorous validation, we deliver reliable & future-ready AI development services.",
            className: "forth",
        },
    ],
    centerImages: {
        desktop: "/images/roadmap-fff.svg",
        tablet: "/images/roadmap-tablet/roadmap4-tab.png",
    },
    rightColumn: [
        {
            title: "Discovery & Planning",
            description:
                "We collaborate to understand your goals, create a roadmap, & align our AI solutions with your business vision, ensuring seamless planning & high-quality results.",
            className: "first",
        },
        {
            title: "Implementation & Support",
            description:
                "We bring your project to life with expert implementation. From setting clear goals to offering ongoing support, we ensure your AI solutions are always optimized.",
            className: "third",
        },
    ],
};

export const aiDevCoverTheStack = {
    secondContent: {
        sectionDescription: "At Bitsclan, we ensure that your DevOps processes are powered by the most advanced technologies available. Our carefully curated tech stack is designed to maximize efficiency, security, & scalability at every stage of the software development lifecycle.",
        mainHeading: "Optimize Your AI Development with Industry-Leading Tech Stack",
        defaultOpenTab: "Libraries"
    },
    tabs: [
        "Generative AI Models",
        "Modules/Toolkits",
        "Deep Learning (DL) Frameworks",
        "Neural Networks",
        "Libraries",
        "Image Classification Models",
    ],

    tabItems: [
        {
            tab: "Generative AI Models",
            icon: "/images/genai1.svg",
            name: "CycleGAN",
        },
        {
            tab: "Generative AI Models",
            icon: "/images/genai2.svg",
            name: "DeepArt",
        },
        {
            tab: "Generative AI Models",
            icon: "/images/genai3.svg",
            name: "DeepDream",
        },
        { tab: "Generative AI Models", icon: "/images/genai4.svg", name: "VQ-VAE" },
        { tab: "Generative AI Models", icon: "/images/genai5.svg", name: "GPT-4" },
        { tab: "Generative AI Models", icon: "/images/genai6.svg", name: "GPT-3" },
        { tab: "Generative AI Models", icon: "/images/genai6.svg", name: "DALL-E" },
        { tab: "Modules/Toolkits", icon: "/images/genai6.svg", name: "OpenAI GPT" },
        {
            tab: "Modules/Toolkits",
            icon: "/images/genai6.svg",
            name: "OpenAI DALL-E",
        },
        {
            tab: "Modules/Toolkits",
            icon: "/images/module1.svg",
            name: "DeepMind Sonnet",
        },
        {
            tab: "Modules/Toolkits",
            icon: "/images/module2.svg",
            name: "Facebook AI Research ",
        },
        {
            tab: "Modules/Toolkits",
            icon: "/images/module3.svg",
            name: "Hugging Face",
        },
        {
            tab: "Modules/Toolkits",
            icon: "/images/module4.svg",
            name: "NVIDIA StyleGAN",
        },
        {
            tab: "Deep Learning (DL) Frameworks",
            icon: "/images/tech-icon.svg",
            name: "PyTorch",
        },
        {
            tab: "Deep Learning (DL) Frameworks",
            icon: "/images/tech-icon2.svg",
            name: "Keras",
        },
        {
            tab: "Deep Learning (DL) Frameworks",
            icon: "/images/tech-icon3.svg",
            name: "MXNet",
        },
        {
            tab: "Deep Learning (DL) Frameworks",
            icon: "/images/tech-icon4.svg",
            name: "TensorFlow",
        },
        {
            tab: "Deep Learning (DL) Frameworks",
            icon: "/images/tech-icon5.svg",
            name: "Caffe",
        },
        { tab: "Neural Networks", icon: "/images/natural1.svg", name: "RBM" },
        { tab: "Neural Networks", icon: "/images/natural2.svg", name: "DBN" },
        {
            tab: "Neural Networks",
            icon: "/images/natural7.svg",
            name: "Transformers",
        },
        {
            tab: "Neural Networks",
            icon: "/images/natural4.svg",
            name: "Autoencoders",
        },
        { tab: "Neural Networks", icon: "/images/natural5.svg", name: "DRLN" },
        { tab: "Neural Networks", icon: "/images/natural6.svg", name: "GAN" },
        { tab: "Libraries", icon: "/images/tech-icon.svg", name: "PyTorch" },
        { tab: "Libraries", icon: "/images/tech-icon2.svg", name: "Keras" },
        { tab: "Libraries", icon: "/images/tech-icon3.svg", name: "MXNet" },
        { tab: "Libraries", icon: "/images/libraries1.svg", name: "FastAI" },
        { tab: "Libraries", icon: "/images/libraries2.svg", name: "TensorFlow" },
        { tab: "Libraries", icon: "/images/libraries3.svg", name: "Theano" },
        { tab: "Libraries", icon: "/images/libraries4.svg", name: "Scikit-learn" },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification.svg",
            name: "AlexNet",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification2.svg",
            name: "EfficientNet",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification3.svg",
            name: "Xception",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification4.svg",
            name: "DenseNet",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification5.svg",
            name: "Inception",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification6.svg",
            name: "ResNet",
        },
        {
            tab: "Image Classification Models",
            icon: "/images/calsification7.svg",
            name: "VGGNet",
        },
    ]
}

export const AiDevPageFaqData = {
    sectionContent: {
        mainHeading: "Frequently Asked Questions",
        sectionDescription: "Get quick answers to your questions about our AI development process & services."
    },

    questionAnswer: [
        {
            id: "collapseOne",
            question: "What are AI development services?",
            answer:
                "AI development services refer to any services that utilize artificial intelligence to develop new solutions or modify existing ones with AI integration for enhanced operations, reduced errors, better productivity, increased agility, & scaled revenue.",
        },
        {
            id: "collapseTwo",
            question: "How much does an AI service cost?",
            answer:
                "The cost of the AI services you require depends upon factors like the scope of the project, the technology involved, etc. Typically, an AI service can range anywhere between $5000 to $300,000. As a top-rated AI consulting & development company, Bitsclan IT Solutions offers free of cost AI consultation.",
        },
        {
            id: "collapseThree",
            question: "How long does it take to build an AI product?",
            answer:
                "There is no fixed time for AI product development. The complexity of the product will decide the time required to complete it. A highly complex product with advanced features may take up to 10 to 20 months. On the other hand, a simple product with minimal AI features can take up to 3 to 6 months.",
        },
        {
            id: "fourth",
            question:
                "How can integrating artificial intelligence benefit my business?",
            answer:
                "By integrating AI, decision-making procedures can be improved, repetitive jobs can be automated, & data-driven insights can be obtained. AI can also be used to forecast trends, optimize resource allocation, & personalize client experiences.",
        },
        {
            id: "fifth",
            question: "What is the process of outsourcing AI development services?",
            answer:
                "Outsourcing AI development involves partnering with a specialized AI company to handle your AI projects. The process typically includes initial consultation, requirement gathering, project planning, development, testing, implementation, & ongoing support.",
        },
        {
            id: "sixth",
            question: "Which industries can benefit from AI development services?",
            answer:
                "Numerous industries, including healthcare, finance, retail, manufacturing, logistics, real estate, legal, education, media, agriculture, gaming, & energy, can profit from AI development services.",
        },
        {
            id: "seventh",
            question:
                "Can AI solutions be integrated with my existing systems & workflows?",
            answer:
                "Yes, AI solutions can be seamlessly integrated with your existing systems & workflows. Our experts ensure that the AI technology complements your current infrastructure, enhancing its capabilities without disrupting operations.",
        },
        {
            id: "eighteeth",
            question: "How do you ensure data privacy & security in AI projects?",
            answer:
                "We prioritize data privacy & security in all our AI projects. We implement robust security measures, comply with industry standards, & use encryption & anonymization techniques to protect your data throughout the project lifecycle.",
        },
    ]
}

export var mainBannerImg = {
    backgroundImage: `url(/images/what-we-do/ai-development-services.avif)`,
};

export const schemaData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
        "@type": "Question",
        "name": "How much does an AI service cost?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "The cost of the AI services you require depends upon factors like the scope of the project, the technology involved, etc. Typically, an AI service can range anywhere between $5000 to $300,000. As a top-rated AI consulting & development company, Bitsclan IT Solutions offers free of cost AI consultation."
        }
    }, {
        "@type": "Question",
        "name": "What are AI development services?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "AI development services refer to any services that utilize artificial intelligence to develop new solutions or modify existing ones with AI integration for enhanced operations, reduced errors, better productivity, increased agility, & scaled revenue."
        }
    }, {
        "@type": "Question",
        "name": "How long does it take to build an AI product?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "There is no fixed time for AI product development. The complexity of the product will decide the time required to complete it. A highly complex product with advanced features may take up to 10 to 20 months. On the other hand, a simple product with minimal AI features can take up to 3 to 6 months."
        }
    }, {
        "@type": "Question",
        "name": "How can integrating artificial intelligence benefit my business?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "By integrating AI, decision-making procedures can be improved, repetitive jobs can be automated, & data-driven insights can be obtained. AI can also be used to forecast trends, optimize resource allocation, & personalize client experiences."
        }
    }, {
        "@type": "Question",
        "name": "What is the process of outsourcing AI development services?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Outsourcing AI development involves partnering with a specialized AI company to handle your AI projects. The process typically includes initial consultation, requirement gathering, project planning, development, testing, implementation, & ongoing support."
        }
    }, {
        "@type": "Question",
        "name": "Which industries can benefit from AI development services?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Numerous industries, including healthcare, finance, retail, manufacturing, logistics, real estate, legal, education, media, agriculture, gaming, & energy, can profit from AI development services."
        }
    }, {
        "@type": "Question",
        "name": "Can AI solutions be integrated with my existing systems & workflows?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, AI solutions can be seamlessly integrated with your existing systems & workflows. Our experts ensure that the AI technology complements your current infrastructure, enhancing its capabilities without disrupting operations."
        }
    }, {
        "@type": "Question",
        "name": "How do you ensure data privacy & security in AI projects?",
        "acceptedAnswer": {
            "@type": "Answer",
            "text": "We prioritize data privacy & security in all our AI projects. We implement robust security measures, comply with industry standards, & use encryption & anonymization techniques to protect your data throughout the project lifecycle."
        }
    }]
}